'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002478 from "./presto.-Two-Factor-Auth-View$$anon$78.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002480 from "./presto.-Two-Factor-Auth-View$$anon$80.js";
import * as $j_presto$002etypes$0024$002dSelected$002dSite$0024 from "./presto.types$-Selected-Site$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$77() {
  this.bHv = null;
  this.bHn = null;
  this.bHo = false;
  this.bHw = null;
  this.bHx = false;
  this.bHA = null;
  this.bHt = null;
  this.bHu = false;
  this.bHp = null;
  this.bHq = false;
  this.bHr = null;
  this.bHs = false;
  this.bHy = false;
  this.bHz = false;
  this.bHv = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bHA = "SelectedSite";
}
export { $c_Lpresto_TwoFactorAuthView$$anon$77 as $c_Lpresto_TwoFactorAuthView$$anon$77 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$77.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$77;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$77() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$77 as $h_Lpresto_TwoFactorAuthView$$anon$77 };
$h_Lpresto_TwoFactorAuthView$$anon$77.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.bHv;
});
$p.L = (function() {
  if ((!this.bHo)) {
    this.bHn = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bHo = true;
  }
  return this.bHn;
});
$p.O = (function() {
  if ((!this.bHx)) {
    this.bHw = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bHx = true;
  }
  return this.bHw;
});
$p.E = (function() {
  return this.bHA;
});
$p.t = (function() {
  if ((!this.bHu)) {
    this.bHt = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("site", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("selected", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bHu = true;
  }
  return this.bHt;
});
$p.M = (function() {
  if ((!this.bHq)) {
    this.bHp = ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002478.$c_Lpresto_TwoFactorAuthView$$anon$78(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().ar, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.bHq = true;
  }
  return this.bHp;
});
$p.Q = (function() {
  if ((!this.bHs)) {
    this.bHr = new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002480.$c_Lpresto_TwoFactorAuthView$$anon$80();
    this.bHs = true;
  }
  return this.bHr;
});
$p.w = (function() {
  if ((!this.bHz)) {
    this.bHy = false;
    this.bHz = true;
  }
  return this.bHy;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee864) => ((p) => \u03b4scrutinee864.add(p)))($j_presto$002etypes$0024$002dSelected$002dSite$0024.$m_Lpresto_types$SelectedSite$())));
});
var $d_Lpresto_TwoFactorAuthView$$anon$77 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$77, "presto.TwoFactorAuthView$$anon$77", ({
  Th: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$77 as $d_Lpresto_TwoFactorAuthView$$anon$77 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$77.js.map
